export type AsyncRetryReturnType<T> =
  | {
      retry: () => void;
      loading: boolean;
      error?: undefined;
      value?: undefined;
    }
  | {
      retry: () => void;
      loading: false;
      error: Error;
      value?: undefined;
    }
  | {
      retry: () => void;
      loading: true;
      error?: Error | undefined;
      value?: T | undefined;
    }
  | {
      retry: () => void;
      loading: false;
      error?: undefined;
      value: T;
    };

export enum SecurityView {
  greetMfaActivated = 'GREET_MFA_ACTIVATED',
  greetMfaDeactivated = 'GREET_MFA_DEACTIVATED',
  qrCode = 'QR_CODE',
  mfaDesc = 'MFA_DESC',
  ssoDesc = 'SSO_DESC'
  // , backupCodes = 'BACKUP_CODES'
}

export interface ISsoConfiguration {
  emailDomain: string;
  company: {
    id: string;
  };
  enabled: boolean;
  enforceSSO?: boolean;
  allowNewUserCreationFromSSO?: boolean;
  provider: string;
}

export interface ISsoEntityIdAndReplyUrl {
  entityId: string;
  replyUrl: string;
}
